export default "__VITE_ASSET__CweR1$Sb__"